import type { Product } from '../type';

export const uniqueArrayOfObjects = (array: Product[]) => {
  const uniqueIds = new Set();
  return array.filter((item) => {
    const isNotDuplicate = !uniqueIds.has(item.id);
    uniqueIds.add(item.id);
    return isNotDuplicate;
  });
};

export const notFoundInList = (item: { id: string }, list: Product[]) => {
  return !list.find((listItem: { id: string }) => listItem.id === item.id);
};

export const saveList = (params: { data: Product[]; list: Product[] }) => {
  const { data, list } = params;
  const cachedList = [] as Product[];

  for (const item of data) {
    const isNotInStore = notFoundInList(item, list);
    if (isNotInStore) cachedList.push(item);
  }
  list.push(...cachedList);
};
